<template>
  <!-- Odstranit velikost -->
  <svg
    width="73"
    height="70"
    viewBox="0 0 73 70"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="M54.324.112c-8.466-.007-15.853 5.72-17.923 13.896C33.968 4.144 23.966-1.888 14.062.535 5.766 2.565-.05 9.995 0 18.504c0 4.74 2.165 9.318 4.75 12.874C13.358 43.25 36.401 70 36.401 70s24.388-27.72 31.63-38.602c1.91-2.85 4.75-8.174 4.75-12.874C72.792 8.367 64.534.124 54.336.112h-.012z"
        fill="#4F2B1B"
      />
      <path
        d="M44.262 39.387c2.653 0 4.87-1.107 6.653-3.32 1.782-2.214 2.673-4.981 2.673-8.301 0-2.832-.814-5.217-2.442-7.154-1.627-1.937-3.637-2.905-6.03-2.905-3.125 0-6.128 2.148-9.009 6.445-3.076-4.313-6.298-6.47-9.668-6.47-2.555 0-4.744 1.136-6.567 3.406-1.823 2.27-2.734 5.001-2.734 8.191 0 2.946.818 5.367 2.453 7.263 1.636 1.897 3.715 2.845 6.238 2.845 3.255 0 6.144-1.986 8.667-5.957 3.662 3.971 6.917 5.957 9.766 5.957zm1.172-6.494c-1.71 0-3.85-1.628-6.421-4.883 1.432-2.263 2.543-3.756 3.332-4.48.79-.724 1.713-1.087 2.771-1.087 1.107 0 2.039.48 2.796 1.44.756.961 1.135 2.15 1.135 3.565 0 3.63-1.205 5.445-3.613 5.445zm-19.58 2.05c-2.637 0-3.956-1.709-3.956-5.127 0-1.53.302-2.79.904-3.784.602-.993 1.367-1.489 2.295-1.489 1.692 0 3.857 1.758 6.494 5.273-1.384 2.084-2.45 3.46-3.198 4.126-.75.668-1.595 1.001-2.54 1.001z"
        fill="#EE9F3F"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>
